module.exports = __webpack_public_path__ + "static/media/sura-phone.89e06de4.svg";